import { FC } from 'react';
import NextImage from 'src/shared-components/NextImage/NextImage';
import { FormattedMessage } from 'react-intl';
import useMedia from 'src/hooks/useMedia';
import SearchInput from 'src/shared-components/SearchInput/SearchInput';
import { useRouter } from 'next/router';
import trns from './trns';
import NavigationLink from '../../shared-components/NavigationLink/NavigationLink';
import { PROD_DOMAIN, TEST_DOMAIN } from '../../api/constants';
import {
  getEnvVariable,
  NEXT_PUBLIC_ENV,
  NEXT_PUBLIC_ENV_VARIANT
} from '../../utils/envVariablesHelper';

interface Props {
  searchInputRef: React.MutableRefObject<HTMLDivElement>;
  errorCode?: string;
}

const SearchPanel: FC<Props> = ({ searchInputRef, errorCode }) => {
  const { xs } = useMedia();
  const router = useRouter();

  const logoImage = 'shared/logo.svg';

  const currentEnv = getEnvVariable(NEXT_PUBLIC_ENV);

  const getEnvDomain = () => {
    if (currentEnv === NEXT_PUBLIC_ENV_VARIANT.PROD) {
      return PROD_DOMAIN;
    }
    if (currentEnv === NEXT_PUBLIC_ENV_VARIANT.STAGE) {
      return TEST_DOMAIN;
    }
    return '/';
  };

  return (
    <div className="flex-col relative w-full items-center justify-center z-40 px-5 xl:px-0">
      <div>
        <div className="flex flex-col items-center w-full justify-center text-astronautBlue fs-header2-reg uppercase text-center mb-10 xl:items-end xl:flex-row  lm:items-end lm:flex-row sm:items-end sm:flex-row">
          <div className="flex flex-col items-center xl:items-end lm:items-end sm:items-end">
            <div className="logo flex flex-row items-center justify-center cursor-pointer mt-10 mb-10">
              <div
                itemScope
                itemType="http://schema.org/Organization"
                className="flex"
              >
                <NavigationLink
                  href={`${getEnvDomain()}${
                    router.locale === 'ru' ? '/ru' : ''
                  }`}
                >
                  <NextImage
                    alt="Справочник лекарств LIKIE"
                    title="Справочник лекарств"
                    src={logoImage}
                    layout="fixed"
                    itemProp="logo"
                    quality={100}
                    width={200}
                    height={90}
                  />
                </NavigationLink>
              </div>
            </div>
            <span className="fs-header3-bold">
              <FormattedMessage {...trns.oops} />
            </span>
            <span className="fs-header3-bold sm:text-end">
              <FormattedMessage {...trns.errorPageTitle} />
            </span>
          </div>
          {errorCode && (
            <div className="fs-header1-bold m-0 l:ml-24 sm:ml-24">
              {errorCode}
            </div>
          )}
        </div>
      </div>
      <div className="flex items-center justify-center flex-col">
        <div className="fs-header5-reg mb-9 text-center text-mako">
          <FormattedMessage {...trns.errorDescription} />
        </div>
        <div className="text-astronautBlue fs-body-reg mb-[53px]">
          <span>
            <FormattedMessage {...trns.returnTo} />
          </span>{' '}
          <NavigationLink href={'/'}>
            <span className="uppercase underline ">
              <FormattedMessage {...trns.main} />
            </span>
          </NavigationLink>
        </div>
      </div>
      {searchInputRef && (
        <div className="flex items-center justify-center w-full h-60	bg-wildSand">
          <div
            ref={searchInputRef}
            className="compendium-max-w-170 w-full bottom-11 z-10 px-5 flex-col justify-center mb-5 items-center"
          >
            <div className="fs-header5-bold mb-10 uppercase text-astronautBlue text-center">
              <FormattedMessage {...trns.searchTitle} />
            </div>
            <SearchInput withIcon={!xs} />
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchPanel;
